import React, { PureComponent } from 'react';
import axios from 'axios';
import FooterContentView from './footerContent/footerContentView';
import FooterContentEdit from './footerContent/footerContentEdit';
import appConstant from '../../../constants/app';

const fetchContentData = () =>  axios.get(`${appConstant.API_URL}/footer`)

class FooterContent extends PureComponent {
  state = {
    isEditSection: false,
    socialMediaLinksList: [],
    disclaimerText: '',
    disclaimerTextHidden: null,
    footerContentData: [],
  }

  componentDidMount () {
    fetchContentData()
    .then(res => {
      const footerContentData = res.data.footer;
      this.onChangeSocialMediaLinksList(footerContentData.social_networks);
      this.setState({
        footerContentData,
        disclaimerText: footerContentData.disclaimer_text,
        disclaimerTextHidden: footerContentData.hidden,
      });
    }).catch(error => {
      console.log(error);
    })
  }

  onChangeSocialMediaLinksList = (list) => {
    this.setState({
      socialMediaLinksList: list,
    })
  };

  onChangeItem = (newValue, key, index) => {
    const {
      socialMediaLinksList,
    } = this.state;

    const newList = socialMediaLinksList.map(item => item);

    newList[index][key] = newValue;

    this.setState({ socialMediaLinksList: newList });
  };

  onChangeFileItem = (event, index) => {
    const {
      socialMediaLinksList,
    } = this.state;

    const newArray = socialMediaLinksList.map(item => item);
    newArray[index].icon = event.target.files[0];
    this.setState({
      socialMediaLinksList: newArray,
    })
  }

  onChangeDisclaimer = (event) => {
    this.setState({ disclaimerText: event })
  }

  addSocialMediaLinkItem = () => {
    let position = this.state.socialMediaLinksList.length > 0 ? this.state.socialMediaLinksList.reduce((prev, current) => (prev.y > current.y) ? prev : current).position + 1 : 1;

    const newElement = {
      'id': null,
      'icon': '',
      'url': '',
      'hidden': 0,
      "position": position,
    }

    this.setState(prevState => ({
      socialMediaLinksList: [...prevState.socialMediaLinksList, newElement]
      })
    );
  };

  hideItem = (index) => {
    const {
      socialMediaLinksList,
    } = this.state;

    const newList = socialMediaLinksList.map(item => item);
    newList[index]['hidden'] = newList[index]['hidden'] === 0 ? 1: 0;
    this.setState({ socialMediaLinksList: newList });
  };

  deleteItem = (item) => {
    const newList = this.state.socialMediaLinksList.filter(element => ( element !== item ));

    this.setState({
      socialMediaLinksList: newList,
    });
  };

  hideDisclaimer = () => {
    this.setState({
      disclaimerTextHidden : this.state.disclaimerTextHidden === 0 ? 1: 0,
    })
  }

  onCancelEdit = () => {
    fetchContentData()
      .then(({data:footerContentData}) => {
        this.onChangeSocialMediaLinksList(footerContentData.footer.social_networks);
        this.setState({
          footerContentData: footerContentData.footer,
          disclaimerText: footerContentData.footer.disclaimer_text,
          disclaimerTextHidden: footerContentData.footer.hidden,
        });
      })

    this.setState({ isEditSection: false });
  }

  render() {
    const {
      isEditSection,
      socialMediaLinksList,
      footerContentData,
      disclaimerText,
      disclaimerTextHidden,
    } = this.state;

    return (
      <div>
        {
          !isEditSection
          ? <FooterContentView
              onClickEdit={
                () => {
                  this.setState({ isEditSection: true });
                }
              }
              socialMedia={socialMediaLinksList}
              onChangeSocialMediaList={this.onChangeSocialMediaLinksList}
              footerContent={footerContentData}
            />
          : <FooterContentEdit
              socialNetworks={socialMediaLinksList}
              disclaimerText={disclaimerText}
              disclaimerTextHidden={disclaimerTextHidden}
              hideDisclaimer={this.hideDisclaimer}
              addSocialMediaLinkItem={this.addSocialMediaLinkItem}
              hideItem={this.hideItem}
              deleteItem={this.deleteItem}
              onChangeItem={this.onChangeItem}
              onChangeFileItem={this.onChangeFileItem}
              onChangeDisclaimer={this.onChangeDisclaimer}
              onClickCancelEdit={this.onCancelEdit}
            />
        }
      </div>
    );
  }
}

export default FooterContent;


// WEBPACK FOOTER //
// ./src/app/screens/general/footerContent.js